import { useEffect } from "react";

export default function Destination(){
    useEffect(() => {
        window.scrollTo(0, 0);
        return () => {
            window.scrollTo(0, 0);
        };
    }, []);

    const destinations = [
        {
            image:"../images/destinations/Antarctica.jpg",
            place:"Antarctica"
        },{
            image:"../images/destinations/Australia.jpg",
            place:"Australia"
        },{
            image:"../images/destinations/Azerbaijan.jpg",
            place:"Azerbaijan"
        },{
            image:"../images/destinations/Cambodia.jpg",
            place:"Cambodia"
        },{
            image:"../images/destinations/Dubai.webp",
            place:"Dubai"
        },{
            image:"../images/destinations/Egypt.jpg",
            place:"Egypt"
        },{
            image:"../images/destinations/Europe.jpg",
            place:"Europe"
        },{
            image:"../images/destinations/Greece.jpg",
            place:"Greece"
        },{
            image:"../images/destinations/Hong Kong.jpg",
            place:"Hong Kong"
        },{
            image:"../images/destinations/Iceland.jpg",
            place:"Iceland"
        },{
            image:"../images/destinations/India.jpg",
            place:"India"
        },{
            image:"../images/destinations/Indonesia.jpg",
            place:"Indonesia"
        },{
            image:"../images/destinations/Japan.jpg",
            place:"Japan"
        },{
            image:"../images/destinations/Kazakhstan.jpg",
            place:"Kazakhstan"
        },{
            image:"../images/destinations/Kenya.jpg",
            place:"Kenya"
        },{
            image:"../images/destinations/London.webp",
            place:"London"
        },{
            image:"../images/destinations/Maldives.jpg",
            place:"Maldives"
        },{
            image:"../images/destinations/Mauritius.jpg",
            place:"Mauritius"
        },{
            image:"../images/destinations/New Zealand.jpg",
            place:"New Zealand"
        },{
            image:"../images/destinations/Norway.jpg",
            place:"Norway"
        },{
            image:"../images/destinations/Paris.jpg",
            place:"Paris"
        },{
            image:"../images/destinations/Rome.webp",
            place:"Rome"
        },{
            image:"../images/destinations/Russia.jpg",
            place:"Russia"
        },{
            image:"../images/destinations/Seychelles.jpg",
            place:"Seychelles"
        },{
            image:"../images/destinations/South Africa.jpg",
            place:"South Africa"
        },{
            image:"../images/destinations/South America.jpg",
            place:"South America"
        },{
            image:"../images/destinations/Spain.webp",
            place:"Spain"
        },{
            image:"../images/destinations/Swiss.webp",
            place:"Swiss"
        },{
            image:"../images/destinations/Thailand.webp",
            place:"Thailand"
        },{
            image:"../images/destinations/Turkey.jpg",
            place:"Turkey"
        },{
            image:"../images/destinations/United States of America.jpg",
            place:"United States of America"
        },{
            image:"../images/destinations/Vietnam.jpg",
            place:"Vietnam"
        },
    ]
    return(
        <section className="wrapper container topDestination" style={{marginBottom:"0", paddingBottom:"7rem", paddingTop:"5rem"}}>
            <header>
                <p>Explore the World with Travel&nbsp;Wise:</p>
                <h2>The Adventure Begins:<br/>Where Will Your Next Journey Take You?</h2>
            </header>
            <main>
                {destinations.map((destination, key)=>(
                    <figure>
                        <img src={destination.image} alt={destination.place}/>
                        <div/>
                        <p>{destination.place}<span>.</span></p>
                    </figure>
                ))}
            </main>
            <h3 style={{textAlign:"center", width:"100%", fontSize:"32px"}} className="subTitle">More ...</h3>
        </section>
    )
}